module.exports = __webpack_public_path__ + "img/england-flag.0f4586bf.svg";